import TableHead, { TableHeadProps } from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Box from "@mui/material/Box";
import pick from "lodash/pick";
import { CSSProperties, memo } from "react";
import { LinearProgress } from "@mui/material";
import { useStyles } from "../DataTable.styles";
import { Column } from "../DataTable.type";
import { FilterCell } from "./FilterCell";
import useJStyles from "$hooks/useJStyles";

type Props = {
  thead?: Column[];
  isLoading?: boolean;
  isVirtualized?: boolean;
} & TableHeadProps;

export const Thead = memo(
  ({ thead, isLoading, isVirtualized = false, ...tableHeadProps }: Props) => {
    const classes = useStyles();
    const { jclasses } = useJStyles();

    // SEE maybe will make the loading here, this will change anyway for the filters
    if (!thead?.length) {
      return null;
    }

    return (
      <TableHead className={classes.tableTitle} {...tableHeadProps}>
        <TableRow
          style={
            isVirtualized
              ? { display: "table-header-group", width: "100%" }
              : {}
          }
        >
          {thead?.map((column: Column) => {
            const styles = pick(column, [
              "minWidth",
              "maxWitdh",
              "width",
              "style",
            ]) as unknown as CSSProperties;
            const { valueFilter, ...filter } = column.filter || {};
            return (
              <TableCell
                key={column.id}
                align={column.align}
                className={classes.tableCell}
                style={{ ...styles }}
                padding="none"
              >
                <Box className={classes.tableCellIn}>
                  {
                    // eslint-disable-next-line react/jsx-no-useless-fragment
                    column.label && !column.filter && (
                      <Box className={jclasses.jTopHead}>{column.label}</Box>
                    )
                  }
                  {filter && <FilterCell {...filter} name={column.id} />}
                </Box>
              </TableCell>
            );
          })}
        </TableRow>
        {isLoading && (
          <tr style={{ height: 4 }}>
            <td colSpan={1000}>
              <LinearProgress />
            </td>
          </tr>
        )}
      </TableHead>
    );
  }
);
